<script>
  import { _ } from 'svelte-i18n';

  export let doc = false;

  export let title;

  let metaDescription, metaTitle;
  if (
    !title &&
    doc &&
    doc.data &&
    Array.isArray(doc.data.title) &&
    doc.data.title[0].text
  ) {
    title = doc.data.title[0].text;
  } else if (
    !title &&
    doc &&
    doc.data &&
    !Array.isArray(doc.data.title) &&
    doc.data.title
  ) {
    title = doc.data.title;
  } else if (!title) {
    title = $_('common.title');
  }

  if (doc && doc.data) {
    metaDescription = doc.data.meta_description || doc.data.description;
    metaTitle = doc.data.meta_title || doc.data.title;
  }

  let ogImageUrl = 'https://bokamera.se/logo.svg';
  if (doc && doc.data && doc.data.heading_image) {
    ogImageUrl = doc.data.heading_image.url;
  }
</script>

<svelte:head>
  <title>{title}</title>
  {#if metaDescription}
    <meta name="description" content={metaDescription} />
  {/if}
  <meta
    name="apple-itunes-app"
    content="app-id=738027900, affiliate-data=myAffiliateData,
    app-argument=https://itunes.apple.com/se/app/bokamera/id738027900?mt=8&amp;uo=4" />
  <meta property="fb:app_id" content="358050477614166" />
  <meta property="og:url" content="https://bokamera.se/" />
  <!-- <base href="/"  /> -->
  {#if metaTitle}
    <meta property="og:title" content={metaTitle} />
  {/if}
  {#if metaDescription}
    <meta property="og:description" content={metaDescription} />
  {/if}
  <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
  <meta property="og:image:type" content="image/png" />
  <meta property="og:image" content={ogImageUrl} />
  <meta name="twitter:card" content="summary_large_image" />
</svelte:head>
